/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-workspace-route-page',
  template: `
    <adn-workspace-list-page
      [readOnly]="readOnly">
    </adn-workspace-list-page>
  `
})
export class WorkspaceRoutePageComponent {
  @Input() readOnly = false;
}
